var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKadena(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2202",
    style: {
      enableBackground: "new 0 0 2000 2202"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000101070196456686843120000001239366859508046510_);}\n\t.st2{fill:#69009A;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 891.3809,
    y1: 1149.9335,
    x2: 1398.6709,
    y2: 423.2734,
    gradientTransform: "matrix(1 0 0 -1 0 2199.8899)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA078C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69009A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1047.4,809.8l57,74c0,0,343,503.8,514.8,755.3c118.5,174.5,237,349,355.7,523.4c9.1,12.5,17.5,25.5,25.1,38.9 c-211.2,0.9-422.4,0.4-633.5,0.2c-210.2-312-627.5-938.1-627.5-938.1l-36-65.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146464880745551454490000007775799416201540268_",
    gradientUnits: "userSpaceOnUse",
    x1: 454.6503,
    y1: 1157.1993,
    x2: 1486.3802,
    y2: 1791.3192,
    gradientTransform: "matrix(1 0 0 -1 0 2199.8899)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA078C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69009A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146464880745551454490000007775799416201540268_)"
    },
    d: "M554,1455.2c-7.8,6.2-7.2,16.5-7.2,25.5 l-8.5,28.4l-41.1-660.7l50.3-53.8c12.9-8.8,512.4-536.8,752.8-788.2c5.7-8,16-5.6,24.4-6.3c209.2,0.7,627.5,0.5,627.5,0.5 S614.9,1390.6,554,1455.2z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0.7h547.4v2200.1H0V0.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKadena);
export default __webpack_public_path__ + "static/media/kadena.c21e791492f1e7bc5bd7958c205595ec.svg";
export { ForwardRef as ReactComponent };